<template>
  <div>
    <CompanyDeposit v-if="isOffice" />
    <SupperDealerDeposit v-if="isSupperDealer" />
  </div>
</template>

<script>
import CompanyDeposit from './company/index'
import SupperDealerDeposit from './supper-dealer/index'
export default {
  name: 'deposit',
  components: {
    CompanyDeposit,
    SupperDealerDeposit
  },
  data() {
    return {}
  },
  computed: {
    isOffice() {
      return this.$store.state.authUser
        ? this.$store.state.authUser.user_type == 1
        : false
    },
    isSupperDealer() {
      if (this.$store.state.authUser) {
        return (
          this.$store.state.authUser.user_type == 2
        )
      }
      return false
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('accounting/supperDeposit/RESET_STATE')
    this.$store.commit('accounting/companyDeposit/RESET_STATE')
    next()
  }
}
</script>
